<template>
    <b-dropdown position="is-bottom-left">
        <a class="navbar-item cart" slot="trigger">
            <span class="icon">
                <i class="fas fa-user"></i>
            </span>

            <span class="is-hidden-mobile">{{ name }}</span>
        </a>

        <b-dropdown-item has-link>
            <router-link :to="{ name: 'Account' }">Mis Datos</router-link>
        </b-dropdown-item>

        <b-dropdown-item has-link>
            <router-link :to="{ name: 'Orders' }">Pedidos</router-link>
        </b-dropdown-item>

        <hr class="dropdown-divider">

        <b-dropdown-item @click="onLogoutSelected">
            <span>Salir</span>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
    export default {
        name: 'MyAccountMenu',

        data() {
            return {}
        },

        computed: {
            name() {
                return this.$store.getters['user/get'].firstName;
            }
        },

        methods: {
            onLogoutSelected() {
                this.$store.dispatch('user/logout');
                this.$store.dispatch('customer/clear');
                this.$router.push('/').catch(err => {});
            }
        },
    }
</script>

<style lang="scss" scoped>
    .navbar-item {
        color: white;

        &:hover {
            color: white;
        }
    }
    
    .black {
        .navbar-item {
            color: black;

            &:hover {
                color: black;
            }
        }
    }
</style>